import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header d-flex justify-content-between" }
const _hoisted_5 = { class: "modal-title fw-bold text-black" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-x" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "modal-footer" }
const _hoisted_10 = {
  key: 0,
  class: "text-center w-100"
}
const _hoisted_11 = {
  key: 1,
  type: "submit",
  class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepForm = _resolveComponent("StepForm")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: _ctx.id,
    tabindex: "-1",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t('feature.surveys.$steps.add')), 1 /* TEXT */),
            _createElementVNode("button", {
              class: "bg-transparent border-0 close-btn lh-1 p-10 text-muted",
              type: "button",
              "data-bs-dismiss": "modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.restoreData()))
            }, [..._hoisted_7])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_StepForm, {
              step: _ctx.step,
              update: false,
              submitted: _ctx.submitted,
              errors: _ctx.errors
            }, null, 8 /* PROPS */, ["step", "submitted", "errors"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_SpinnerLoading)
                ]))
              : (_openBlock(), _createElementBlock("button", _hoisted_11, _toDisplayString(_ctx.$t('feature.surveys.$steps.save')), 1 /* TEXT */))
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}